import { Box, Link, Stack, styled } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { IJob } from 'wisestep-api';
import {
  theme,
  WsColors,
  WsIconCompanyLogo,
  WsTypoColors,
  WsTypography,
  WsTypoVariants,
} from 'wisestep-base';

import { useJobSettingsContext } from '../../../../../../context/jobsListContext';
import { getAccountManagerAnalyticsUrl } from '../../../../../candidates/utils/CandidateHelper';
import ClientDetailsCard from '../../clientDetailsCard';

const BoxTheme = styled(Box)(() => ({
  borderRadius: 2,
  backgroundColor: WsColors.TertiaryShades50,
  padding: theme.spacing(2),
  margin: theme.spacing(2),
}));

interface clientDetailsProps {
  job: IJob;
}
const ClientDetails = ({ job }: clientDetailsProps) => {
  const jobSettings = useJobSettingsContext();
  const navigate = useNavigate();
  return (
    <BoxTheme>
      <Box justifyContent="center">
        <Stack direction="row" spacing={2}>
          <WsIconCompanyLogo />
          <Box pt={2}>
            {job.companyName && jobSettings.companyName?.hide === false && (
              <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK}>
                {job.companyName}
              </WsTypography>
            )}
          </Box>
        </Stack>
      </Box>
      <Stack direction="row" mb={3} mt={4} spacing={2}>
        {job.hiringFor && jobSettings.hiringFor?.hide === false && (
          <ClientDetailsCard titleType="Client Type" titleText={job.hiringFor} />
        )}
        {job.clientJobCode && jobSettings.clientJobCode?.hide === false && (
          <ClientDetailsCard titleType="Client Job Code" titleText={job.clientJobCode} />
        )}
        {/* <Stack direction="row" mb={3}>
        {job.jobIndustryName && jobSettings.jobIndustryName?.hide === false && (
          <ClientDetailsCard titleType="Industry" titleText={job.jobIndustryName} />
        )}
        {job.department && <ClientDetailsCard titleType="Department" titleText={job.department} />}
         </Stack> */}
        {job?.clientRecruiterName && !/.*xxxxxx.*/.test(job.clientRecruiterName)
          ? job.clientRecruiterName &&
            jobSettings.clientRecruiterName?.hide === false && (
              <Link
                href={`/${job?.clientContactId}/client-contact-details?isChild=true&name=${
                  job?.companyName
                }&goBack=true&clientId=${job?.clientId ?? ''}&goBackUrl=/jobs-crm/${
                  job.id
                }/false/0/pipeline`}
                underline={'none'}
              >
                <ClientDetailsCard
                  titleType="Client Recruiter"
                  titleText={job.clientRecruiterName}
                />
              </Link>
            )
          : job.clientRecruiterName && (
              <ClientDetailsCard titleType="Client Recruiter" titleText={job.clientRecruiterName} />
            )}
        {job.accountManagerName && jobSettings.accountManagerName?.hide === false && (
          <ClientDetailsCard
            titleType="Account Manager"
            titleText={job.accountManagerName}
            onClickTitleText={async () => {
              if (job.accountManagerEmail) {
                const url = await getAccountManagerAnalyticsUrl(job.accountManagerEmail);
                url && navigate(url);
              }
            }}
          />
        )}
      </Stack>
    </BoxTheme>
  );
};

export default ClientDetails;
